import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Button, Callout, Typography } from 'seagull';
import { useQboTimeActivities } from '~/hooks/reactQuery/queries/useQboTimeActivities';
import { useNonNullableRelationship } from '~/hooks/reactQuery/queries/useRelationship';
import { useLocaleKeys } from '~/i18n';
import { getAccountingDetails } from '~/integrations/Accounting/accounting.utils';
import { useOpenMapServicesModal } from '~/integrations/Accounting/MapServicesModal/useOpenMapServicesModal';
import { Accounting } from '~/types/api.model';
export default function MapServicesCallout(param) {
    let { accounting, relationshipId } = param;
    const { t } = useLocaleKeys('mapServicesCallout');
    const { refresh: refreshQboTimeActivities } = useQboTimeActivities(relationshipId);
    const { relationship, optimisticUpdate } = useNonNullableRelationship(relationshipId);
    const setServiceIntegratedId = useMemo(()=>{
        switch(accounting){
            case Accounting.QBO:
                return (integrations, integratedId)=>integrations.setQboIntegratedId(integratedId);
            case Accounting.Xero:
                return (integrations, integratedId)=>integrations.setXeroIntegratedId(integratedId);
        }
    }, [
        accounting
    ]);
    const serviceTemplateIds = getAccountingDetails(accounting).policy.getServiceTemplateIdsFromServices(relationship.services);
    const openMapServicesModal = useOpenMapServicesModal(serviceTemplateIds, async (change)=>{
        if (accounting === Accounting.QBO) await refreshQboTimeActivities();
        optimisticUpdate((agreement)=>_object_spread_props(_object_spread({}, agreement), {
                services: agreement.services.map((service)=>service.serviceTemplateId === change.serviceTemplateId ? _object_spread_props(_object_spread({}, service), {
                        integrations: setServiceIntegratedId(service.integrations, change.accountingItemId)
                    }) : service)
            }));
    });
    return /*#__PURE__*/ _jsx(Callout, {
        withAction: /*#__PURE__*/ _jsx(Button, {
            bi: {
                name: 'map_services_from_callout'
            },
            testId: "map-services-".concat(accounting),
            onClick: ()=>openMapServicesModal(accounting),
            children: t.mapServices()
        }),
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: "map-services-callout-".concat(accounting),
            children: t.servicesNotMapped({
                accountingName: getAccountingDetails(accounting).fullName
            })
        })
    });
}
